import React from 'react';
import classnames from 'classnames';

import i18n from 'i18next';
import { NestedListContainer } from '@/exceed';

import { Checkbox } from 'uikit/inputs';

import { Typo } from 'uikit/content';

import getNestedTopics from '../helpers/getNestedTopics';

import ThreeStateCheckbox from './threeStateCheckbox';

import styles from '../styles/topicTagMappingList.module.scss';

const TopicTagMappingList = ({
  allTopics,
  hasSearch,
  onSectionToggle,
  onTopicToggle,
  topics,
  topicSelection,
}) => {
  const getIsSelected = ({ id }) => topicSelection.map((topic) => topic.id).includes(id);

  const getSectionState = (section) => {
    if (getIsSelected(section)) return true;

    return getNestedTopics(section, allTopics).some(getIsSelected) ? null : false;
  };

  const getTopicState = (topic, section) => (
    getIsSelected(topic) || Boolean(getSectionState(section))
  );

  return (
    <div className={classnames(hasSearch && styles.isSearching)}>
      {!topics.length ? (
        <Typo className={classnames(styles.text, styles.empty)} variant="b01">
          {i18n.t('topics-empty')}
        </Typo>
      ) : topics.map((topic) => {
        const { id, name, topics: nestedTopics } = topic;

        return (
          <NestedListContainer
            bodyAriaLabel={name}
            bodyClassName={styles.body}
            key={id}
            header={<Typo className={styles.text} variant="b01">{name}</Typo>}
            headerPrepend={(
              <ThreeStateCheckbox
                onChange={(isChecked) => onSectionToggle(isChecked, topic)}
                value={getSectionState(topic)}
              />
            )}
            hasToggle={!hasSearch}
            id={id}
            isExpanded={hasSearch}
            toggleButtonSize="xsmall"
          >
            {nestedTopics.map((nestedTopic) => {
              const isSelected = getTopicState(nestedTopic, topic);
              const nestedId = nestedTopic.id;

              return (
                <Checkbox
                  className={styles.checkbox}
                  id={`topic-tag-mapping-${nestedId}`}
                  key={nestedId}
                  label={nestedTopic.name}
                  onChange={(checked) => onTopicToggle(checked, nestedTopic, topic)}
                  value={isSelected}
                />
              );
            })}
          </NestedListContainer>
        );
      })}
    </div>
  );
};

export default React.memo(TopicTagMappingList);
